var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocationHeartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 145618",
  fill: "none",
  d: "M0 0h24v24H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.241 4.051a5.911 5.911 0 00-8.414 0l-.828.828-.824-.828a5.951 5.951 0 00-8.416 8.416L12 21.708l9.241-9.241a5.911 5.911 0 000-8.414",
  fill: "#f96506",
  stroke: "#f96506",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
})));
export default __webpack_public_path__ + "static/location-heart-icon.092bb50fea1b215fd985278437ec3a06.svg";
export { SvgLocationHeartIcon as ReactComponent };